<template>
  <div class="tab-content">
    <el-tabs activeName="first">
      <el-tab-pane :label="$t('vendor_tab_files_first')" name="first">
        <el-card>

          <el-button @click="addComment" size="mini" type="primary" plain icon="el-icon-plus">{{$t('project_tab_comments_first_btn_postComment')}}</el-button>

          <el-timeline v-if="commentsList.length" style="padding-top: 20px;">
            <el-timeline-item
              v-for="item in commentsList"
              :key="item.id"
              :timestamp="moment(item.createdDate).format('LLLL')"
              placement="top">
              <div :id="item.id">
                <el-card class="card">
                  <div slot="header" class="card__header">
                    <div class="card__status">
                      <div class="photo-group" v-if="item.user">
                        <img v-if="item.user.avatarUrl" :src="item.user.avatarUrl">
                      </div>
                      <el-tag size="small" type="success" style="margin-right: 10px;" v-html="item.user.fullName"></el-tag>
                    </div>
                  </div>
                  <div class="text item">
                    <div>
                      <p style="margin: 0;"><strong>{{$t('project_tab_comments_first_notes')}}:</strong></p>
                      <div v-html="item.text" class="info-progress"></div>
                    </div>
                  </div>
                </el-card>
              </div>
            </el-timeline-item>
          </el-timeline>

          <sweet-modal blocking :title="$t('modal_postComment')" ref="addComment" class="modal" v-on:close="closeModal">
            <el-form label-position="top" label-width="0" :model="form" status-icon ref="form" class="demo-ruleForm">
              <el-form-item>
                <vue2-custom-editor
                  ref="editor"
                  v-model="form.text">
                </vue2-custom-editor>
              </el-form-item>

              <el-form-item>
                <el-switch v-model="form.sendNotification" active-text="Send Notification" style="margin-right: 20px;"></el-switch>
                <el-switch v-if="selectedRow.assignSupplyChainMgr" v-model="form.sendNotificationTeam" active-text="Send Notification Team"></el-switch>
              </el-form-item>

              <el-form-item  class="modal__btn">
                <el-button @click="modalCancel('addComment')">{{$t('general_cancel')}}</el-button>
                <el-button @click="addCommentSubmit" type="primary">{{$t('general_submit')}}</el-button>
              </el-form-item>
            </el-form>
          </sweet-modal>

        </el-card>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
  import Vue2CustomEditor from "../vue-2-custom-editor";
  let moment = require('moment')
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';
  import axios from 'axios'

  export default  {
    name: 'vendor-comments',
    props: ['bookmarkListProject', 'selectedRow', 'projectPermission'],
    components:{
      Vue2CustomEditor,
      SweetModal
    },
    data() {
      return {
        moment:moment,

        commentsList: [],
        form: {
          text: '',
          sendNotification: false,
          sendNotificationTeam: false,
        },
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    methods:{
      loadList() {
        let loader = this.$loading.show()
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString()
        axios.get(`/api/v1/comments/get?entityId=${this.selectedRow.vendorId}&entityTypeId=2`)
          .then(response => {
            this.commentsList = response.data.data
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          })
      },
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      addComment(){
        this.$refs.addComment.open();
      },
      addCommentSubmit(){
        let loader = this.$loading.show()
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString()
        axios.post(`/api/v1/client-vendor/comments/create?companyId=${this.$route.query.companyId}`, {
          text: this.form.text,
          entityId: this.$route.query.companyClientId,
          userId: this.user.user.id,
          entityType: 'client',
          sendNotification: this.form.sendNotification,
          sendNotificationTeam: this.form.sendNotificationTeam,
        })
          .then(response => {
            console.log('---response.data', response.data)
            this.notification(this.$i18n.t('notification_title_success'), this.$i18n.t('success_addComment'), "success")
            this.loadList()
            this.$refs.addComment.close()
            loader.hide()
          })
          .catch(error => {
            this.notification("Notification", error.response.data.message, "info")
            loader.hide()
            console.log('An error occurred:', error);
          })
      },
      closeModal(){
        this.form.text = ''
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
.add-comment-btn{
  margin-bottom:15px;
}
.box-card{
  margin: 10px 0;
}
.sweet-modal-overlay{
  z-index:1000;
}
.card__status{
  display:flex;
  align-items: center;
}
.photo-group{
  overflow:hidden;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 20px;
  background: url('~@/assets/img/user-default.jpg');
  background-size: cover;
  img{
    width:100%;
    height:100%;
  }
}
.flex-twocolumn{
  display:flex;
  .el-form-item__content{
    margin:0 12px;
    font-size:13px;
    &:first-child {
      margin-left: 0px;
    }
  }
}
/deep/ ul.el-timeline {
  padding-inline-start: 0px;
}

.text {
  position: relative;
  font-size: 14px;
}

.hovered-node{
  -webkit-box-shadow: 0 0 26px 5px #409EFF;
  box-shadow: 0 0 10px 5px #409EFF;
}
</style>
